import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../../config/config'

function initialState() {
    return {
        all: [],
        loading: false,
        current: 1
    }
}

const getters = {
    all: state => state.all,
    loading: state => state.loading,
    current: state => state.current
}

const actions = {
    fetchAll({
        commit,
        state
    }) {
        commit('setLoading', true)
        Http.get(API_URL + VERSION + '/countries-for-tourist-visa')
            .then(response => {
                commit('setAll', response.data.data)
            })
            .catch(error => {
                const message = error.response.data.message || error.message
                commit('setError', message)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    resetState({
        commit
    }) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setCurrent(state, value) {
        state.current = value
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}